<div class="box">
    <div class="content" fxFlex="100">
        <div class="Header" fxFlex="100">
            <span> Commercial </span>
            <!-- <span class="desc">Provide your remarks for updating the request status.</span> -->
        </div>

        <div fxLayout="row" *ngIf="commercials.latest_quote!=null" class="w-100">
            <!-- <span class="title">Commercial</span> -->
            <div class="commercialTable">
                <span class="desc"> Below are the details of {{label}}:</span>
                <div class="colHeader">
                    <div class="Head header" fxFlex="48"> <span>Particulars</span></div>
                    <div class="Head dataHead" fxFlex="48"><span>Commercials</span></div>
                </div>
                <ng-container *ngIf="requestType=='one_way'">
                    <div class="colData">
                        <div class="Head" fxFlex="48">Quantity</div>
                        <div class="data" fxFlex="48">{{commercialData?.quantity ?? '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Pick-Up Charge/cont.</div>
                        <div class="data" fxFlex="48">{{commercialData?.pickup_charge ?? '-'}}
                            {{commercialData?.pickup_charge_currency ?? '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Payee</div>
                        <div class="data" fxFlex="48">{{commercialData?.payee=='arcon' ? 'Arcon pays' :
                            commercialData?.payee=='customer' ?
                            'User pays' : commercialData?.payee=='supplier' ? 'Supplier pays' : '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Free Days</div>
                        <div class="data" fxFlex="48">{{commercialData?.min_free_days ?? '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Max usage days</div>
                        <div class="data" fxFlex="48">{{commercialData?.max_free_days ?? '-' }}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Per Diem/cont. (in USD)</div>
                        <div class="data" fxFlex="48">{{commercialData?.min_per_diem ?? '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Max. Per Diem/cont. (in USD)</div>
                        <div class="data" fxFlex="48">{{commercialData?.max_per_diem ?? '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">DPP/cont.</div>
                        <div class="data" fxFlex="48">{{commercialData?.dpp_charge ?? '-'}}
                            {{commercialData?.dpp_charge_currency ?? '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Storage Charge/cont.</div>
                        <div class="data" fxFlex="48">{{commercialData?.storage_charge ?? '-'}}
                            {{commercialData?.storage_charge_currency ?? '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Insurance</div>
                        <ng-container *ngIf="commercialData?.insurance">
                            <div class="data vstack" fxFlex="48">
                                <span> {{commercialData?.insurance.name}}</span>
                                <span class="desc">{{commercialData?.insurance_premium ?? '-'}}
                                    {{commercialData?.insurance_premium_currency}}
                                </span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="!commercials?.latest_quote?.insurance">
                            <div class="data vstack" fxFlex="48"> -</div>
                        </ng-container>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Drop-off Fee/cont.</div>
                        <div class="data" fxFlex="48">{{commercialData?.dropoff_charge ?? '-'}}
                            {{commercialData?.dpp_charge_currency ?? '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Cancellation Fee/cont.</div>
                        <div class="data" fxFlex="48">{{commercialData?.cancellation_charge ?? '-'}}
                            {{commercialData?.cancellation_charge_currency ?? '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">New Build Price</div>
                        <div class="data" fxFlex="48">{{commercialData?.drv_new_build_price ?? '-'}}
                            {{commercialData?.drv_new_build_price_currency ?? '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Depreciation Per Year</div>
                        <div class="data" fxFlex="48">
                            {{commercialData?.drv_depreciation_per_year ? commercialData?.drv_depreciation_per_year+' %' : '-'}}
                        </div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Maximum Depreciation</div>
                        <div class="data" fxFlex="48">
                            {{commercialData?.drv_max_depreciation_percent ? commercialData?.drv_max_depreciation_percent+' %' : '-'}}
                        </div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Remarks</div>
                        <div class="data" fxFlex="48">{{commercialData?.remarks ?? '-'}}</div>
                    </div>
                </ng-container>
                <ng-container *ngIf="requestType=='buy_sell'">
                    <div class="colData">
                        <div class="Head" fxFlex="48">Quantity</div>
                        <div class="data" fxFlex="48">{{commercialData?.quantity ?? '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Minimum Buy-price</div>
                        <div class="data" fxFlex="48">
                            {{commercialData?.price ?? '-'}} {{commercialData?.price_currency ??
                            '-'}}
                        </div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Storage charge/cont.</div>
                        <div class="data" fxFlex="48">
                            {{commercialData?.storage_charge ?? '-'}} {{commercialData?.storage_charge_currency ?? '-'}}
                        </div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Manufacturing Year of Containers</div>
                        <div class="data" fxFlex="48">{{commercialData?.min_manufacturing_year ?? '-'}} |
                            {{commercialData?.max_manufacturing_year ?? '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Color Preference</div>
                        <ng-container *ngIf="!commercialData?.color_preference">
                            <div class="data vstack" fxFlex="48"> -</div>
                        </ng-container>
                        <ng-container *ngIf="commercialData?.color_preference">
                            <div class="data hstack" fxFlex="48">
                                <div class="color-box"
                                    [style]="'background:'+commercialData?.color_preference?.HEX+' ;'">

                                </div>
                                <div class="hstack ralcode">
                                    <span>{{commercialData?.color_preference?.RAL ?? '-'}}</span>
                                    <span class="desc">
                                        {{commercialData?.color_preference?.name ?? '-'}}</span>
                                </div>
                            </div>
                        </ng-container>

                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Readiness date for Pick-up</div>
                        <div class="data" fxFlex="48">
                            {{commercialData?.pickup_ready_date ?? '-' | date:'dd MMM, yyyy'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Container Condition</div>
                        <div class="data" fxFlex="48">{{commercialData?.condition?.value ?? '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Purpose of Container</div>
                        <div class="data" fxFlex="48">{{commercialData?.purpose ?? '-'}}</div>
                    </div>
                    <!--<div class="colData">
                        <div class="Head" fxFlex="48">Req. gets automatically cancelled in</div>
                        <div class="data" fxFlex="48">
                            {{commercialData?.quote_valid_till ?? '-' | date:'dd MMM, yyyy'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Remarks</div>
                        <div class="data" fxFlex="48">{{commercialData?.remarks ?? '-'}}</div>
                    </div> -->

                </ng-container>
                <ng-container *ngIf="requestType=='lease'">
                    <div class="colData">
                        <div class="Head" fxFlex="48">Per Diem charge</div>
                        <div class="data" fxFlex="48">{{commercialData?.per_diem_charge ?? '-'}}
                            {{commercialData?.per_diem_charge_currency ?? '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Open for Negotiation</div>
                        <div class="data" fxFlex="48">{{commercialData?.negotiation_percent ?? '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Tentative Pick-up start date</div>
                        <div class="data" fxFlex="48">{{commercialData?.tentative_pickup_date ?? '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Manufacturing Year of Containers</div>
                        <div class="data" fxFlex="48">{{commercialData?.min_manufacturing_year ?? '-'}} -
                            {{commercialData?.max_manufacturing_year ?? '-'}}</div>
                    </div>
                    <div class="colData">
                        <div class="Head" fxFlex="48">Remarks</div>
                        <div class="data" fxFlex="48">{{commercialData?.remarks ?? '-'}}</div>
                    </div>
                </ng-container>
            </div>
            <div class="input" fxFlex="100" *ngIf="!isExternalUser">
                <div class="field">
                    <span>Remarks*</span>
                    <app-text-field [isMultiline]="true" [isEditable]="true" [(ngModel)]="statusChangeObject.remarks"
                        [name]="'request'" [errors]="errorObj.remarks">
                    </app-text-field>
                </div>
            </div>
        </div>

    </div>
    <div class="btnSet" fxFlex="100" *ngIf="!isExternalUser">
        <button mat-raised-button class="Save" (click)="confirmBooking()">

            <span *ngIf="!disableSaveButton"> {{isCustomer?'Accept Quote':'Confirm Booking'}}</span>
            <div *ngIf="disableSaveButton" class="p03"><i class="flaticon-loading spin"></i>
                <span> {{isCustomer?'Accepting Quote Details...':'Confirming Booking Details...'}}</span>
            </div>
        </button>
    </div>
</div>